import type { RouteRecordRaw } from 'vue-router';
export const routes: RouteRecordRaw[] = [
  {
    path: 'liquidation',
    component: () => import('./views/liquidation-index.vue'),
    meta: {
      layoutFeatures: {
        actionPanel: true,
      },
    },
    children: [
      {
        path: '',
        component: () => import('./views/liquidation-overview.vue'),
      },
    ],
  },
];
export default routes;
